import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=21dacf12&scoped=true"
import script from "./newHome.vue?vue&type=script&lang=js"
export * from "./newHome.vue?vue&type=script&lang=js"
import style0 from "./newHome.vue?vue&type=style&index=0&id=21dacf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dacf12",
  null
  
)

export default component.exports